export default [
    {
        type: "lathe",
        noise: 0.02,
        segments: 14,
        vertices: [
            0.000001, 0.006, 0.13, 0.018, 0.341, 0.084, 0.437, 0.144, 0.492, 0.234, 0.484, 0.246, 0.276, 0.232, 0.107,
            0.284, 0.046, 0.346, 0.062, 0.852, 0.097, 0.956, 0.166, 0.998,
        ],
    },
    {
        type: "lathe",
        noise: 0.02,
        segments: 10,
        vertices: [
            0.000001, 0.562, 0.091, 0.572, 0.172, 0.61, 0.223, 0.666, 0.256, 0.74, 0.258, 0.806, 0.246, 0.824, 0.062,
            0.826, 0.065, 0.948, 0.097, 0.998,
        ],
    },
    {
        type: "lathe",
        noise: 0.02,
        segments: 10,
        vertices: [
            0.000001, 0.768, 0.099, 0.772, 0.219, 0.802, 0.306, 0.844, 0.352, 0.886, 0.352, 0.908, 0.118, 0.904, 0.107,
            0.93, 0.115, 0.966, 0.14, 0.996,
        ],
    },
];
